import moment from 'moment'
import { getDuration } from 'shared/time-utilites'
import styles from '../styles.module.scss'

export const TicketInfo = ({ ticket }) => {
    const { parkingStartDate, parkingEndTime, ticketNumber } = ticket

    return (
        <div className="mb-3">
            <div className={styles.ticketDataRow}>
                <span>
                    <T>scanticket.ticketinfo.ticket.number</T>:{' '}
                </span>
                <span>{ticketNumber}</span>
            </div>
            <div className={styles.ticketDataRow}>
                <span>
                    <T>scanticket.ticketinfo.parking.start</T>:{' '}
                </span>
                <span>{moment(parkingStartDate).format('MMMM D, YYYY HH:mm')}</span>
            </div>
            <div className={styles.ticketDataRow}>
                <span>
                    <T>scanticket.ticketinfo.parking.end</T>:{' '}
                </span>
                <span>{moment(parkingEndTime).format('MMMM D, YYYY HH:mm')}</span>
            </div>
            <div className={styles.ticketDataRow}>
                <span>
                    <T>scanticket.ticketinfo.parking.duration</T>:{' '}
                </span>
                <span>{getDuration(parkingStartDate, parkingEndTime)}</span>
            </div>
        </div>
    )
}
